import React, { useCallback, useEffect, useState } from "react";
import {
  MdLastPage,
  MdNavigateNext,
  MdNavigateBefore,
  MdFirstPage,
} from "react-icons/md";
import PropTypes from "prop-types";
import Button from "../Buttons";
import SearchControl from "../Forms/SearchControl/SearchControl";
import WidgetCard from "../Cards/WidgetCard";
import * as S from "./CardWithPagination.Style";
import { usePaginate } from "../../../hooks";

const PaginationControls = ({
  goTo,
  takeNext,
  takePrevious,
  takeFirst,
  takeLast,
  currentPage,
  pages,
}) => {
  const [
    [leftIndex, middleIndex, rightIndex],
    setTresBotoesPaginacao,
  ] = useState([1, 2, 3]);

  const changePageHandle = useCallback(
    (pageIndex) => {
      goTo(pageIndex);
    },
    [goTo]
  );

  const leftButtonHandle = useCallback(() => {
    changePageHandle(leftIndex);
  }, [changePageHandle, leftIndex]);

  const middleButtonHandle = useCallback(() => {
    changePageHandle(middleIndex);
  }, [changePageHandle, middleIndex]);

  const rightButtonHandle = useCallback(() => {
    changePageHandle(rightIndex);
  }, [changePageHandle, rightIndex]);

  useEffect(() => {
    if (currentPage <= 2) {
      setTresBotoesPaginacao([1, 2, 3]);
    } else if (currentPage >= pages - 1) {
      setTresBotoesPaginacao([pages - 2, pages - 1, pages]);
    } else {
      setTresBotoesPaginacao([currentPage - 1, currentPage, currentPage + 1]);
    }
  }, [currentPage, pages]);

  return (
    <>
      <S.PagesButtonsContent>
        <S.NextAndPreviousButtons
          as={Button}
          onClick={takeFirst}
          disabled={currentPage === 1}
        >
          <MdFirstPage />
        </S.NextAndPreviousButtons>
        <S.NextAndPreviousButtons
          as={Button}
          onClick={takePrevious}
          disabled={currentPage === 1}
        >
          <MdNavigateBefore />
        </S.NextAndPreviousButtons>
        <S.TresBotoesPaginacao
          as={Button}
          onClick={leftButtonHandle}
          selected={leftIndex === currentPage}
        >
          {leftIndex}
        </S.TresBotoesPaginacao>
        <S.TresBotoesPaginacao
          as={Button}
          onClick={middleButtonHandle}
          selected={middleIndex === currentPage}
          disabled={pages <= 1}
        >
          {middleIndex}
        </S.TresBotoesPaginacao>
        <S.TresBotoesPaginacao
          as={Button}
          onClick={rightButtonHandle}
          selected={rightIndex === currentPage}
          disabled={pages <= 2}
        >
          {rightIndex}
        </S.TresBotoesPaginacao>
        <S.NextAndPreviousButtons
          as={Button}
          onClick={takeNext}
          disabled={currentPage === pages}
        >
          <MdNavigateNext />
        </S.NextAndPreviousButtons>
        <S.NextAndPreviousButtons
          as={Button}
          onClick={takeLast}
          disabled={currentPage >= pages}
        >
          <MdLastPage />
        </S.NextAndPreviousButtons>
      </S.PagesButtonsContent>
    </>
  );
};

PaginationControls.propTypes = {
  goTo: PropTypes.func.isRequired,
  takeNext: PropTypes.func.isRequired,
  takePrevious: PropTypes.func.isRequired,
  takeFirst: PropTypes.func.isRequired,
  takeLast: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
};

const CardWithPagination = ({
  listaCompleta,
  onSearchCondition,
  listagemDeItens,
  limitPage,
}) => {
  const paginateHook = usePaginate({
    pageSize: limitPage,
    list: listaCompleta,
  });

  const { items, setList, goTo } = paginateHook;

  const setSearchHandle = useCallback(
    (value) => {
      const searchItems = listaCompleta.filter(
        (element) => !value || onSearchCondition(element, value)
      );
      setList(searchItems);
      goTo(1);
    },
    [goTo, listaCompleta, onSearchCondition, setList]
  );
  return (
    <>
      <SearchControl
        name="Procura de sorteados"
        type="number"
        onChange={(e) => setSearchHandle(e.currentTarget.value)}
        placeholder="Informe um número para pesquisar"
      />
      <S.ModalWidgetCard as={WidgetCard} header={<>{listagemDeItens(items)}</>}>
        <PaginationControls {...paginateHook} />
      </S.ModalWidgetCard>
    </>
  );
};

CardWithPagination.propTypes = {
  listaCompleta: PropTypes.arrayOf(Object).isRequired,
  limitPage: PropTypes.number.isRequired,
  onSearchCondition: PropTypes.func.isRequired,
  listagemDeItens: PropTypes.func.isRequired,
};

export default CardWithPagination;
